export function deepAssign( target, ...sources ) {
	for ( let source of sources ) {
		for ( let k in source ) {
			let vs = source[ k ], vt = target[ k ];
			if ( Object( vs ) == vs && Object( vt ) === vt ) {
				target[ k ] = deepAssign( vt, vs );
				continue;
			}
			target[ k ] = source[ k ];
		}
	}
	return target;
}


export function hexToRgba( hex, opacity ) {
	const r = parseInt( hex.substring( 1, 3 ), 16 );
	const g = parseInt( hex.substring( 3, 5 ), 16 );
	const b = parseInt( hex.substring( 5, 7 ), 16 );
	return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
